// Module
var code = `<div class="jumbotron-surface scene-content-surface">

  <!-- The colour of the scene is the only inline colour of this panel. It is on
       the edge below the head, so the operator sees which scene the panel is for. -->
  <div class="jumbotron-panel-head has-scene-colour scene-content-head" ng-style="{'border-bottom-color': ctrl.scene.color}">
    <div class="scene-content-head-main" ng-click="ctrl.isCollapsed = !ctrl.isCollapsed">
      <i class="fas fa-fw scene-content-chevron" aria-hidden="true"
        ng-class="{'fa-chevron-right': ctrl.isCollapsed, 'fa-chevron-down': !ctrl.isCollapsed}"></i>
      <span class="jumbotron-heading scene-content-title" ng-show="!ctrl.activeSceneCollection">Scene content</span>
      <span class="jumbotron-heading scene-content-title" ng-show="ctrl.activeSceneCollection">{{ ctrl.activeSceneCollection.name }}</span>
      <button type="button" class="btn btn-sm btn-outline-secondary" ng-show="ctrl.activeSceneCollection"
        ng-click="ctrl.removeActiveSceneCollection(); \$event.stopPropagation();">
        <i class="fas fa-arrow-left" aria-hidden="true"></i> <span class="d-none d-sm-inline">Back</span>
      </button>
    </div>

    <div class="scene-content-actions">
      <a class="btn btn-sm btn-outline-primary" ng-hide="ctrl.activeSceneCollection"
        ui-sref="manager.scene-calendar({ id: ctrl.scene.id })" title="Open Calendar View">
        <i class="fas fa-calendar-alt" aria-hidden="true"></i> Calendar
      </a>
      <button type="button" class="btn btn-sm btn-discreet-danger" ng-show="ctrl.activeSceneCollection"
        ng-click="\$event.stopPropagation(); ctrl.deleteAllSceneCollectionItems()"
        ng-disabled="ctrl.isDeleting || ctrl.activeSceneCollectionItems.length === 0"
        title="Delete every item of this playlist">
        <i class="fas fa-trash-alt" aria-hidden="true"></i> <span class="d-none d-md-inline">Delete All</span>
      </button>
      <button type="button" class="btn btn-sm btn-outline-primary" ng-show="ctrl.activeSceneCollection"
        ng-click="\$event.stopPropagation(); ctrl.copySceneCollection(ctrl.activeSceneCollection.id)"
        ng-disabled="ctrl.isDeleting || ctrl.activeSceneCollectionItems.length === 0"
        title="Copy every item of this playlist">
        <i class="fas fa-copy" aria-hidden="true"></i> <span class="d-none d-md-inline">Copy</span>
      </button>
      <button type="button" class="btn btn-sm btn-outline-primary"
        ng-show="ctrl.activeSceneCollection && ctrl.copiedSceneCollectionId"
        ng-click="\$event.stopPropagation(); ctrl.pasteSceneCollectionItems(ctrl.activeSceneCollection.id)"
        title="Paste the copied items into this playlist">
        <i class="fas fa-paste" aria-hidden="true"></i> <span class="d-none d-md-inline">Paste</span>
      </button>
      <a class="btn btn-sm btn-outline-primary" ng-show="ctrl.activeSceneCollection"
        ui-sref="manager.scene-compose({ id: ctrl.scene.id, collectionId: ctrl.activeSceneCollection.id })"
        title="Compose the order">
        <i class="fas fa-sliders" aria-hidden="true"></i> <span class="d-none d-md-inline">Compose</span>
      </a>
      <span class="jumbotron-note scene-content-total d-none d-lg-block" ng-show="ctrl.activeSceneCollection">{{
        ctrl.activeSceneCollection.totalDuration | duration }}</span>
    </div>
  </div>

  <div class="scene-content-body" ng-show="!ctrl.isCollapsed">
    <empty-info ng-show="ctrl.sceneCollections.length === 0 && !ctrl.showNewCollectionForm"
      no="content"></empty-info>
    <empty-info ng-show="ctrl.activeSceneCollection && ctrl.activeSceneCollectionItems.length === 0"
      no="content"></empty-info>

    <ul class="scene-content-list" drag-drop-list="ctrl.collectionDrop"
      drag-drop-list-count="ctrl.sceneCollections.length"
      ng-show="(ctrl.sceneCollections.length > 0 || ctrl.showNewCollectionForm) && !ctrl.activeSceneCollection">
      <li class="scene-content-row" data-drag-collection drag-drop-row="ctrl.collectionDrop"
        drag-drop-row-id="item.id" drag-drop-row-index="\$index"
        ng-attr-draggable="{{ctrl.editingCollectionId === item.id ? 'false' : 'true'}}"
        ng-repeat="item in ctrl.sceneCollections | orderBy:'priority' track by item.id">
        <div class="scene-content-line" ng-if="ctrl.editingCollectionId !== item.id">
          <span class="drag-handle" title="Drag to reorder">
            <i class="fas fa-grip-vertical" aria-hidden="true"></i>
          </span>
          <button class="btn btn-sm btn-outline-primary scene-content-name" type="button"
            ng-click="ctrl.setActiveSceneCollection(item.id)">
            <span class="scene-content-name-line">
              <span class="scene-content-name-text">
                <i ng-if="item.id === ctrl.playingSceneCollection" class="jumbotron-live-mark fas fa-play scene-content-playing"
                  aria-hidden="true"></i>
                <span class="text-truncate">{{ item.name }}</span>
              </span>
              <i class="fas fa-list scene-content-name-icon" aria-hidden="true"></i>
            </span>
          </button>
          <div class="scene-content-meta">
            <span class="jumbotron-note scene-content-duration d-none d-md-inline-flex">
              <i class="far fa-clock" aria-hidden="true"></i> {{ item.totalDuration | duration }}
            </span>
            <!-- The mark opens the intervals of the playlist. A pointer opens them
                 on a desktop and a tap opens them on a telephone. -->
            <div ng-if="ctrl.getActiveIntervals(item).length > 0" class="scene-content-interval"
              ng-click="ctrl.toggleIntervalTooltip(item)">
            <i class="far fa-calendar-alt" aria-hidden="true"></i>
            <div ng-if="item.showIntervals" class="scene-content-tooltip">
              <strong>Scheduled intervals:</strong>
              <div ng-repeat="interval in ctrl.getActiveIntervals(item)" class="scene-content-tooltip-item">{{
                interval.readable_begin }} to {{ interval.readable_end }}<span
                  ng-if="ctrl.roleLabel(interval)"> &middot; {{ ctrl.roleLabel(interval) }}</span>
              </div>
              <div class="scene-content-tooltip-arrow"></div>
            </div>
          </div>
          </div>
          <div class="scene-content-row-buttons">
            <button class="btn btn-sm btn-outline-primary" type="button" ng-click="ctrl.playNow(item.id)"
              ng-disabled="ctrl.isDeleting || !item.totalDuration" aria-label="Play this playlist now"
              ng-attr-title="{{ item.totalDuration ? 'Play Now' : 'The playlist is empty' }}">
              <i class="fas fa-play" aria-hidden="true"></i>
            </button>
            <button class="btn btn-sm btn-outline-primary" type="button" ng-click="ctrl.editCollectionName(item)"
              ng-disabled="ctrl.isDeleting" title="Rename" aria-label="Rename this playlist">
              <i class="fas fa-cog" aria-hidden="true"></i>
            </button>
            <button class="btn btn-sm btn-discreet-danger" type="button"
              ng-click="ctrl.deleteSceneCollection(item.id)" ng-disabled="ctrl.isDeleting" title="Delete"
              aria-label="Delete this playlist">
              <i class="fas fa-fw" aria-hidden="true"
                ng-class="{'fa-spinner fa-spin': ctrl.isDeleting, 'fa-trash': !ctrl.isDeleting}"></i>
            </button>
          </div>
        </div>
        <form class="scene-content-line scene-content-form" ng-if="ctrl.editingCollectionId === item.id"
          ng-submit="ctrl.saveCollectionName(item)">
          <input type="text" class="form-control form-control-sm" placeholder="Enter playlist name"
            aria-label="Name of the playlist" ng-model="ctrl.editedCollectionName" autofocus required>
          <button class="btn btn-sm btn-primary" type="submit">Save</button>
          <button class="btn btn-sm btn-outline-secondary" type="button"
            ng-click="ctrl.cancelEditCollectionName()">Cancel</button>
        </form>
      </li>
      <li class="scene-content-row" ng-show="ctrl.showNewCollectionForm" draggable="false">
        <form class="scene-content-line scene-content-form" ng-submit="ctrl.saveNewSceneCollection()">
          <input type="text" class="form-control form-control-sm" placeholder="Enter playlist name"
            aria-label="Name of the new playlist" ng-model="ctrl.newCollectionName" autofocus required>
          <button class="btn btn-sm btn-primary" type="submit">Save</button>
          <button class="btn btn-sm btn-outline-secondary" type="button"
            ng-click="ctrl.cancelNewSceneCollection()">Cancel</button>
        </form>
      </li>
    </ul>

    <div class="scene-content-scrollable" ng-show="ctrl.activeSceneCollection">
      <ul class="scene-content-list" drag-drop-list="ctrl.itemDrop"
        drag-drop-list-count="ctrl.activeSceneCollectionItems.length">
        <li class="scene-content-row scene-content-line" data-drag-item drag-drop-row="ctrl.itemDrop"
          drag-drop-row-id="sceneCollectionItem.id" drag-drop-row-index="\$index"
          ng-attr-draggable="{{!durationForm.\$visible}}"
          ng-repeat="sceneCollectionItem in
          ctrl.activeSceneCollectionItems | orderBy:'order' track by sceneCollectionItem.id">
          <span class="scene-content-index">
            <strong>{{\$index + 1}}</strong>
            <i class="fas" aria-hidden="true" ng-class="ctrl.typeIcon(sceneCollectionItem.mediaType)"></i>
          </span>
          <!-- The labels of the media are dots. Two dots stand in the first
               column and the rest stand in the second one. -->
          <span class="scene-content-labels">
            <span class="scene-content-label-column" ng-if="sceneCollectionItem.media.labels.length > 0">
              <span ng-repeat="label in sceneCollectionItem.media.labels | limitTo:2 track by label.id"
                class="jumbotron-dot scene-content-label-dot" ng-style="{'background-color': label.color || 'var(--jumbotron-primary)'}"
                title="{{label.name}}"></span>
            </span>
            <span class="scene-content-label-column" ng-if="sceneCollectionItem.media.labels.length > 2">
              <span ng-repeat="label in sceneCollectionItem.media.labels.slice(2) track by label.id"
                class="jumbotron-dot scene-content-label-dot" ng-style="{'background-color': label.color || 'var(--jumbotron-primary)'}"
                title="{{label.name}}"></span>
            </span>
          </span>
          <span class="scene-content-item-name text-truncate" title="{{sceneCollectionItem.media.name}}">
            {{sceneCollectionItem.media.name}}</span>
          <div class="scene-content-row-buttons">
            <form ng-show="durationForm.\$visible" class="scene-content-duration-form" editable-form
              name="durationForm">
              <span e-class="form-control form-control-sm" e-style="max-width: 60px;"
                editable-text="sceneCollectionItem.duration / 1000" e-form="durationForm" e-name="duration" e-required
                onbeforesave="ctrl.validateAndSetDuration(sceneCollectionItem.id, \$data)"></span>
              <button class="btn btn-sm btn-outline-primary" type="submit" ng-disabled="durationForm.\$waiting"
                aria-label="Save the duration"><i class="fas fa-check" aria-hidden="true"></i></button>
              <button class="btn btn-sm btn-outline-primary" type="button" ng-disabled="durationForm.\$waiting"
                ng-click="durationForm.\$cancel()" aria-label="Cancel the duration"><i class="fas fa-times"
                  aria-hidden="true"></i></button>
            </form>
            <button ng-show="!durationForm.\$visible" class="btn btn-sm btn-outline-primary" type="button"
              ng-disabled="!ctrl.durationIsEditable(sceneCollectionItem)" ng-click="durationForm.\$show()">
              {{sceneCollectionItem.duration | duration}}
              <!--TODO: Read correct duration of FileMedia videos-->
              <span ng-if="sceneCollectionItem.mediaType === 'social'"
                class="text-muted d-none d-md-inline">({{sceneCollectionItem.duration / 10000 |
                number:0}} items)</span>
              <!--TODO: Fix hardcoded duration-->
              <i ng-if="ctrl.durationIsEditable(sceneCollectionItem)" class="fas fa-pencil" aria-hidden="true"></i>
            </button>
            <button class="btn btn-sm btn-discreet-danger" type="button"
              ng-click="ctrl.deleteSceneCollectionItem(sceneCollectionItem.id)" ng-disabled="ctrl.isDeleting"
              aria-label="Delete this item">
              <i class="fas fa-fw" aria-hidden="true"
                ng-class="{'fa-spinner fa-spin': ctrl.isDeleting, 'fa-trash': !ctrl.isDeleting}"></i>
            </button>
          </div>
        </li>
      </ul>
    </div>

    <div class="scene-content-foot" ng-if="ctrl.showCreateButton" ng-hide="ctrl.activeSceneCollection">
      <button type="button" class="btn btn-sm btn-outline-primary"
        ng-click="\$event.stopPropagation(); ctrl.createNewSceneCollection();">
        <i class="fas fa-plus-circle" aria-hidden="true"></i> Create new playlist
      </button>
    </div>
  </div>
</div>
`;
// Exports
export default code;